import { Routes, Route, Navigate } from 'react-router-dom';
import { routes } from '../utils/routes';
import {  NOT_FOUND } from '../utils/consts';

function AppRouter() {
  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path} 
          path={route.path}
          element={<route.Component />} 
        />
      ))}
      <Route path="*" element={<Navigate to={NOT_FOUND} replace/>}/>
    </Routes>
  );
}

export default AppRouter;